import React from 'react';
import Team from '../../components/Team/Team';
import ContactUs from '../../components/ContactUs/ContactUs';





const About = () => {
    return (
        <>
          <div className="container">
          <div className="row justify-content-center mt-3 pt-4">

          <iframe width="560" height="315" src="https://www.youtube.com/embed/WhBfrlK1v30" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
          <h5 className="text-center text-white">Our ready-made webVR meeting & social spaces make it easy to</h5>
          <h4 className="text-center text-white">#CloseTheDistance</h4>
      
          <p className="mt-3 text-white">Katabi enables close collaboration through a WebVR experience that closes the distance between remote teams. It is a virtual world space, accessible through a browser or virtual reality headset, with ready-made meeting and social spaces and an easy-to-learn interface.<br/><br/>Backstory: "Katabi ko" means "beside me" in Tagalog, the Filipino language. In quarantine, social distancing no longer allows us to feel the camaraderie of sitting beside someone. </p>
          <h5 className="text-center text-white pb-3">Sit next to someone safely in Katabi</h5>
          <hr/>
        </div>

        <div className="container">
        <h4 className="mt-3 text-center text-white">Stay Connected</h4>
        <p className="mt-3 text-white">We'd love to stay in touch with you as we develop Katabi. Join our mailing list to keep up with updates and participate in our upcoming private beta!</p>
        <div className="row justify-content-center">
        <div className="col-md-4">
        <a href="https://mailchi.mp/43e84e40d3ae/i4uh5mk1oi" className="btn btn-block mailingList" target="_blank">JOIN OUR MAILING LIST</a>
        </div>
        </div>
        <hr/>
        </div>

        {/* <div className="container">
    
        <h4 className="mt-3 text-center text-white">GitHub Links</h4>
      
          <p className="mt-3 text-center text-white"> */}
          {/* <a target="_blank" className="githubLink" href="https://github.com/funksoup/katabi-co">https://github.com/funksoup/katabi-co</a><br/> */}
          {/* <a target="blank" className="githubLink pb-3 mb-3" href="https://github.com/Frans/networked-aframe/tree/master/examples">https://github.com/Frans/networked-aframe/tree/master/examples</a> */}
          {/* </p> */}
      
         
          {/* <hr/>
        </div> */}




          <div className="row">
          <Team />
       
          </div>
          <div className="row">
          <ContactUs />
          </div>
        </>
    )
}

export default About;